import {isEqual} from "lodash";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {userState} from "./user/UserSlice";
import {UserState} from "./user/UserState";
import {setIsOpened} from "./user/userUpdateModal/UserUpdateModalSlice";

const UserUpdateButton = () => {
  const dispatch = useAppDispatch();
  const state: UserState = useAppSelector(userState);

  const {user, originalUser} = state;

  const onUserUpdateButtonPressed = () => {
    dispatch(setIsOpened(true));
  };

  return (
    <div className="row align-items-center">
      <button
        className="btn btn-success my-2 my-sm-0"
        type="button"
        onClick={onUserUpdateButtonPressed}
        disabled={isEqual(user, originalUser)}
      >
        Update... The update fields will be shown before the update
      </button>
    </div>
  );
};

export default UserUpdateButton;
